export const tagTypes = [
    {name: "Adventure Equipment", value: "ADVENTURE_EQUIPMENT"},
    {name: "Superior Equipment", value: "SUPERIOR_EQUIPMENT"},
    {name: "Boon", value: "BOON"},
    {name: "Benefit", value: "COIN_BENEFIT"},
    {name: "Magic Item", value: "MAGIC_ITEM"},
    {name: "LCO Ritual Scroll", value: "LCO_RITUAL_SCROLL"},
    {name: "Silver", value: "COIN"},
    {name: "Crafting Material", value: "CRAFTING_MATERIAL"},
    {name: "LCO Reagent", value: "LCO_REAGENT"}
]

export const repNumberedTypes = ["MAGIC_ITEM", "LCO_RITUAL_SCROLL"]

export function getTagType(s: string) {
    return tagTypes.find((t) => t.name == s)
}

export const tagSources = [
    {name: "Crafting Batch 1", value: "CRAFTING_BATCH_1"},
    {name: "Crafting Batch - Other", value: "CRAFTING_ADDITIONAL_BATCH"},
    {name: "Superior Equipment", value: "SUPERIOR_EQUIPMENT"},
    {name: "Coin Benefit", value: "COIN_BENEFIT"},
    {name: "Goblin Stamps", value: "GOBLIN_STAMPS"},
    {name: "Dragon Stamps", value: "DRAGON_STAMPS"},
    {name: "Previous Game", value: "PREVIOUS_GAME"},
    {name: "Profession", value: "PROFESSION"},
    {name: "Merchant", value: "MERCHANT"},
    {name: "Donation Drive", value: "DONATION_DRIVE"},
    {name: "Starting Wealth", value: "STARTING_WEALTH"}
]

export function getTagSource(s: string) {
    return tagSources.find((t) => t.value == s)?.name
}

export const craftingMaterials = ["Herb", "Ink", "Leather", "Ore", "Vellum"]

export const adventureEquipment = [
    "Alchemical Solvant",
    "Alchemy Recipe Book",
    "Alchemy Globe Trap",
    "Amnesia Elixir",
    "Antidote Elixir",
    "Armor",
    "Armor Patch (10)",
    "Armor Patch (20)",
    "Awaken Potion",
    "Awaken Scroll",
    "Berserk Contact",
    "Berserk Elixir",
    "Berserk Globe",
    "Blast Globe - Normal",
    "Blast Globe - Silver",
    "Blast Globe - Flame",
    "Blast Globe - Ice",
    "Blast Globe - Lightning",
    "Blast Globe - Stone",
    "Break Globe",
    "Break Scroll",
    "Celestial Spellbook",
    "Charm Contact",
    "Charm Elixir",
    "Charm Globe",
    "Charm Potion",
    "Charm Scroll",
    "Cleanse Elixir",
    "Cleanse Potion",
    "Cure Disease Potion",
    "Cure Wounds 5 Elixir",
    "Cure Wounds Potion 5",
    "Cure Wounds Potion 10",
    "Cure Wounds Potion 15",
    "Cure Wounds Potion 20",
    "Cure Wounds Potion 25",
    "Cure Wounds Potion 30",
    "Cure Wounds Potion 35",
    "Cure Wounds Potion 40",
    "Cure Wounds Potion 45",
    "Destruction Potion",
    "Disarm Globe",
    "Disarm Scroll",
    "Disease Potion",
    "Dispel Scroll",
    "Drain Potion",
    "Earth Spellbook",
    "Elemental Shield Potion",
    "Elemental Shield Scroll",
    "Endow Potion",
    "Enfeeble Contact",
    "Enfeeble Elixir",
    "Enfeeble Globe",
    "Enslavement Antidote",
    "Euphoria Antidote",
    "Evocation Bolt Scroll - Flame - 5",
    "Evocation Bolt Scroll - Flame - 10",
    "Evocation Bolt Scroll - Flame - 15",
    "Evocation Bolt Scroll - Flame - 20",
    "Evocation Bolt Scroll - Flame - 25",
    "Evocation Bolt Scroll - Flame - 30",
    "Evocation Bolt Scroll - Flame - 35",
    "Evocation Bolt Scroll - Flame - 40",
    "Evocation Bolt Scroll - Flame - 45",
    "Evocation Bolt Scroll - Ice - 5",
    "Evocation Bolt Scroll - Ice - 10",
    "Evocation Bolt Scroll - Ice - 15",
    "Evocation Bolt Scroll - Ice - 20",
    "Evocation Bolt Scroll - Ice - 25",
    "Evocation Bolt Scroll - Ice - 30",
    "Evocation Bolt Scroll - Ice - 35",
    "Evocation Bolt Scroll - Ice - 40",
    "Evocation Bolt Scroll - Ice - 45",
    "Evocation Bolt Scroll - Lightning - 5",
    "Evocation Bolt Scroll - Lightning - 10",
    "Evocation Bolt Scroll - Lightning - 15",
    "Evocation Bolt Scroll - Lightning - 20",
    "Evocation Bolt Scroll - Lightning - 25",
    "Evocation Bolt Scroll - Lightning - 30",
    "Evocation Bolt Scroll - Lightning - 35",
    "Evocation Bolt Scroll - Lightning - 40",
    "Evocation Bolt Scroll - Lightning - 45",
    "Evocation Bolt Scroll - Stone - 5",
    "Evocation Bolt Scroll - Stone - 10",
    "Evocation Bolt Scroll - Stone - 15",
    "Evocation Bolt Scroll - Stone - 20",
    "Evocation Bolt Scroll - Stone - 25",
    "Evocation Bolt Scroll - Stone - 30",
    "Evocation Bolt Scroll - Stone - 35",
    "Evocation Bolt Scroll - Stone - 40",
    "Evocation Bolt Scroll - Stone - 45",
    "Explosive Trap",
    "Hallucinate Contact",
    "Hallucinate Elixir",
    "Hallucinate Globe",
    "Heavy Crossbow",
    "Heavy Thrown Weapon",
    "Intoxicate",
    "Lesser Investment Scroll",
    "Light Crossbow",
    "Light Scroll",
    "Light Thrown Weapon",
    "Liquid Light",
    "Long Blunt",
    "Long Edged",
    "Longbow",
    "Mechanical Trap",
    "Noisemaker Trap",
    "Oil of Slipperiness",
    "Paralysis Contact",
    "Paralysis Elixir",
    "Paralysis Globe",
    "Paralysis Potion",
    "Paranoia Contact",
    "Paranoia Elixir",
    "Paranoia Globe",
    "Paste of Stickiness",
    "Pin Scroll",
    "Poison Shield Elixir",
    "Polearm",
    "Purify Potion",
    "Reflect Spell Potion",
    "Reflect Spell Scroll",
    "Release Potion",
    "Release Scroll",
    "Repel Scroll",
    "Restore Potion",
    "Scroll Trap",
    "Shackle Globe",
    "Shackle Scroll",
    "Sheild",
    "Short Blunt",
    "Short Bow",
    "Short Edged",
    "Shun Scroll",
    "Silence Globe",
    "Silence Potion",
    "Sleep Contact",
    "Sleep Elixir",
    "Sleep Globe",
    "Sleep Potion",
    "Sleep Scroll",
    "Slow Globe",
    "Slow Scroll",
    "Small Weapon",
    "Spear",
    "Spell Sheild Potion",
    "Spell Sheild Scroll",
    "Staff",
    "Two-Handed Blunt",
    "Two-Handed Sword",
    "Vorpal Coating 10",
    "Vorpal Coating 5",
    "Wall of Force Scroll",
    "Weakness Contact",
    "Weakness Elixir",
    "Weakness Globe",
    "Weakness Potion",
    "Weapon Sheild Scroll",
    "Weapon Shield Potion",
    "Weapon Trap",
    "Web Scroll",
    "Whetstone",
    "Wither Potion",
    "Wizard Lock Scroll",
    "Source - Healing",
    "Source - Chaos",
    "Source - Flame",
    "Source - Ice",
    "Source - Lighting",
    "Source - Stone",
    "Cause Wounds Potion 5",
    "Cause Wounds Potion 10",
    "Cause Wounds Potion 15",
    "Cause Wounds Potion 20",
    "Cause Wounds Potion 25",
    "Cause Wounds Potion 30",
    "Cause Wounds Potion 35",
    "Cause Wounds Potion 40",
    "Cause Wounds Potion 45"
]

export const superiorEquipment = [
    "Advanced Toolkit",
    "Alchemy Toolkit",
    "Amalgam Armament",
    "Apothecary's Relic",
    "Armor of Crushing Counters",
    "Armor of Dispersal",
    "Armor of Reduction",
    "Armor of Vital Reinforcement",
    "Awakening Mace",
    "Bag of Spare Parts",
    "Bow of Deadly Aim",
    "Bow of Enchanted Barrage",
    "Breaching Charge",
    "Brewer's Bow",
    "Brewing Toolkit",
    "Castling Weapon",
    "Channeling Weapon",
    "Circle of Recovery",
    "Cleaving Weapon",
    "Clockwork Web-Spinner",
    "Congealing Powder",
    "Corpselight",
    "Dragon's Breath Distallate",
    "Durable Toolkit",
    "Eat Me Not",
    "Elemental Runed Weapon",
    "Elemental Tuning Fork",
    "Envenomed Quiver",
    "Foundation's Armament",
    "Gel Applicator",
    "Good Night Tea",
    "Greater Evocation Weapon",
    "Greater Healing Weapon",
    "Healing Bandages",
    "Healthstoring Plate",
    "Howlbear Distillate",
    "Inscriber's Tome",
    "Inscription Toolkit",
    "Lesser Evocation Weapon",
    "Lesser Healing Weapon",
    "Liquid Courage",
    "Mentor's Spell Book",
    "Moonshield",
    "Panacea",
    "Piercing Polearm",
    "Poison Spray Crossbow",
    "Protective Inscription",
    "Quill of Alternate Reagents",
    "Quill of Caster's Mark",
    "Quill of Disquised Casting",
    "Quill of Ritual Unification",
    "Quill of Terminate",
    "Rockhide Distillate (10)",
    "Rockhide Distillate (20)",
    "Rod Of Eldritch Berserking",
    "Salvager's Pack",
    "Sanguine Armor",
    "Scorpion's Sting",
    "Scroll Satchel",
    "Sigil Of Foundation",
    "Sigil of Majesty",
    "Smithing Toolkit",
    "Spellsmith Tools",
    "Tinkering Toolkit",
    "Tome of Tempests",
    "Unbinding Blade",
    "Vial of Resistance",
    "Weapon of Banishment",
    "Weapon of Curses",
    "Weapon of Fury",
    "Weapon of Heroism",
    "Weapon of Interception",
    "Weapon of Relentless Strikes",
    "Weapon of Smiting",
    "Weapon of Surprise",
    "Relic of Rejuvenation",
    "Wand of Abundance"
]

export const boons = [
    "Chimera", "Djinn", "Dragon", "Greater Elemental", "Gryphon", "Hydra", "Phoenix"
]

export const benefits = [
    "Well Fed", "Well Rested", "Training","Fill Spell Store","Game Preparations","Earth Guild Casting Package", "Celestial Guild Casting Package"
]

export const lcoScrolls = [
    "Amplified Circle*",
    "Arcane Armor",
    "Armored Shell",
    "Assassin's Edge",
    "Audible Projection",
    "Battlemage's Strike",
    "Blissful Rest",
    "Bloodthirst",
    "Bound Shard",
    "Call to Ages Past*",
    "Channel Armor",
    "Channel Health",
    "Charge Transfer*",
    "Circle Lock",
    "Cloak of Darkness",
    "Contact Other Plane",
    "Cosmetic Transformation",
    "Counterspell",
    "Create Limited Circle of Power",
    "Critical Combined Strike*",
    "Curse of Undeath",
    "Defensive Buffer*",
    "Deflecting Resistance*",
    "Duplicating Evocation*",
    "Elemental Embodiment*",
    "Elemental Imbuement",
    "Elemental Manipulation",
    "Empower Warrior",
    "Empowered Meditation*",
    "Enchant",
    "Encryption / Decryption*",
    "Endure Elements",
    "Energized Weapon*",
    "Enhanced Discipline*",
    "Enhanced Source",
    "Eternal Resolution",
    "Evocation Feedback*",
    "Explosive Demise",
    "Extend Battle Magic Duration",
    "Flexible Combined Strike*",
    "Focused Resistance",
    "Forsee the Weather",
    "Fortify Armor",
    "Foundation's Form*",
    "Ghoulish Grimoire*",
    "Gift of Life",
    "Greater Source",
    "Haven of the Living / Domain of the Defiled",
    "Heal Construct",
    "Healing / Chaos Imbuement",
    "Healing Grace / Horrific Recovery*",
    "Heroic Interception",
    "Homunculus*",
    "Illumination / Darkening",
    "Improved Flexible Casting*",
    "Instant Trap",
    "Intercepting Reflex*",
    "Investiture/Divestiture",
    "Item Cosmetic Transformation",
    "Item Recall",
    "Jack of All Trades",
    "Lesser Renewal*",
    "Life Leech",
    "Lore",
    "Magic Evocation",
    "Magic Imbuement",
    "Magical Claws",
    "Magical Source*",
    "March of the Untiring",
    "Mark / Unmark",
    "Memory Strike",
    "Mending Resolution*",
    "Merchant Insight",
    "Mercurial Weapon*",
    "Mighty Imbuement*",
    "Mist Sense",
    "Monster Slayer",
    "Mystic Smith",
    "Mystical Malleability*",
    "Opportune Rebirth*",
    "Partial Refit*",
    "Perfect Riposte",
    "Planar Asylum",
    "Planar Gate",
    "Planar Sanctum*",
    "Planar Weapon*",
    "Poison Cache",
    "Poison Trigger",
    "Portable Circle of Power*",
    "Portal of Summoning*",
    "Potency",
    "Potion Coating",
    "Preserve Duration",
    "Prismatic Protection*",
    "Proscribe",
    "Quicken Aid",
    "Quicken Meditation",
    "Race Reaver",
    "Racial Transmogrification*",
    "Raging Strike",
    "Rapid Recollection*",
    "Recharge Prowess",
    "Reinforce Armor",
    "Relentless Mettle*",
    "Reliable Channeling*",
    "Reshape Ritual Magic*",
    "Resist Destroy Magic",
    "Resist Shatter",
    "Resonance",
    "Restorative Resistance*",
    "Retribution",
    "Reverse Life Force",
    "Ritual of WoE",
    "Ritualist's Gambit*",
    "Sacrifice",
    "Safe Return*",
    "Sanguine Sacrifice*",
    "Scour Necromantic Magic / Spoil Earth Magic*",
    "Seek the Whole",
    "Shared Imbuement*",
    "Sorcerous Triage",
    "Spark of Memory*",
    "Spell Parry",
    "Spell Store",
    "Spell Swap",
    "Spirit Farewell",
    "Spirit Link",
    "Spirit Lock",
    "Spirit Loop*",
    "Spirit Recall",
    "Spirit Refuge",
    "Spirit Walk",
    "Stalwart Shield",
    "Steal Strength*",
    "Store Ability",
    "Strength from Guile*",
    "Strengthen Spirit",
    "Strengthened Blow",
    "Sturdy Armor",
    "Tempered Armor*",
    "Undeath Denied*",
    "Unification Source*",
    "Universal Speech",
    "Vengeance",
    "Vision",
    "Warder Glyph",
    "Whispering Wind"
]